<template>
  <div class="jobfair">
    <side-bar>
      <div class="header">
        <carousel-top
          :config="carouselConfig"
          :carousel="carouselList"
        ></carousel-top>
        <div class="header-top">
          <header-nav ref="router" @change-province="init"></header-nav>
        </div>
        <section class="wy-search">
          <div class>
            <el-input
              prefix-icon="el-icon-search"
              placeholder="搜索双选会名称、主办方等信息"
              v-model="filter.keywords"
              clearable
              class="input-with-select"
              @change="searchFn"
              :maxlength="25"
            >
              <el-button type="primary" @click="searchFn" slot="append"
                >搜索</el-button
              >
            </el-input>
          </div>
          <!-- <div class="hot-words">
            <span class="iconfont iconhuo1" style="color: #ff6f6f"></span>
            <span>热门搜索：</span>
            <span
              class="hot-word"
              v-for="(item, index) in hot_words.data"
              :key="index"
              @click="checkHotWord(item)"
              >{{ item.name }}</span
            >
          </div> -->
        </section>
      </div>
      <section>
        <!-- 热门推荐 -->
        <section class="ongoing" v-if="list.popular.length > 0">
          <div class="container">
            <el-row>
              <el-col :span="22">
                <ul class="list-title-box">
                  <li class="list-title">
                    <img :src="imgConfig.rocket" alt />
                    <span>热门推荐</span>
                  </li>
                </ul>
              </el-col>
              <el-col :span="2" style="text-align: right;">
                <el-link tye="info" :underline="false" @click="moreFn" style="color:#999999">全部场次 ></el-link>
              </el-col>
            </el-row>
            <div class="jobfair-card-box hot-box" :class="{'hot-opend': hot_open}" >
              <el-row :gutter="20">
                <el-col
                  :span="8"
                  v-for="(item, index) in list.popular"
                  :key="index"
                >
                  <card-jobfair
                    @click.native="toDetailFn(item)"
                    :item="item"
                  ></card-jobfair>
                </el-col>
              </el-row>
            </div>
            <div class="open-more-hot" v-if="list.popular.length > 6" @click="hot_open=!hot_open">
              <span>{{hot_open?'收起':'更多场次'}}</span><i class="el-icon-d-arrow-left down-arrow" :class="{'up-arrow': hot_open}"></i>
            </div>
          </div>
        </section>
        <section class="ongoing">
          <!-- 进行中的  TODO:: 交互问题，如果出现多行那么就不能够左右滑动，不然不是6的整数，滑动非常不好 -->
          <div class="container" >
            <el-row>
              <el-col :span="22">
                <ul class="list-title-box">
                  <li class="list-title">
                    <img :src="imgConfig.rocket" alt />
                    <span>正在进行中</span>
                  </li>
                </ul>
              </el-col>
              <el-col :span="2" style="text-align: right;">
                <el-link tye="info" :underline="false" @click="moreFn" style="color:#999999">全部场次 ></el-link>
              </el-col>
            </el-row>
            <div class="jobfair-card-box hot-box" :class="{'hot-opend': ongoing_open}"  v-if="list.ongoing.length > 0">
              <el-row :gutter="20">
                <el-col
                  :span="8"
                  v-for="(item, index) in list.ongoing"
                  :key="index"
                >
                  <card-jobfair
                    @click.native="toDetailFn(item)"
                    :item="item"
                  ></card-jobfair>
                </el-col>
              </el-row>
            </div>
            <div class="open-more-hot" v-if="list.ongoing.length > 6" @click="ongoing_open=!ongoing_open">
              <span>{{ongoing_open?'收起':'更多场次'}}</span><i class="el-icon-d-arrow-left down-arrow" :class="{'up-arrow': ongoing_open}"></i>
            </div>
            <no-data v-if="list.ongoing.length <= 0"></no-data>
          </div>
        </section>
        <section class="category">
          <!-- TODO:: 类别：1.专场暂时没有 2.在进行中已经展示的数据是否还需要展示 -->
          <div class="container">
            <el-row>
              <el-col :span="22">
                <ul class="list-title-box">
                <li :class="{ 'list-title': sp_keywords.value == item.value }" v-for="(item, index) in sp_keywords.data" :key="index" @click="spChangeFn(item)">
                  <img :src="imgConfig.rocket" alt />
                  <span>{{ item.name }}</span>
                </li>
              </ul>
              </el-col>
              <el-col :span="2">
                <el-link tye="info" :underline="false" @click="moreFn" style="color:#999999">全部场次 ></el-link>
              </el-col>
            </el-row>
            <div class="jobfair-card-box" v-if="list[sp_keywords.value] && list[sp_keywords.value].length > 0">
              <el-row :gutter="20">
                <el-col :span="8" v-for="(item, index) in list[sp_keywords.value]" :key="index">
                  <card-jobfair @click.native="toDetailFn(item)" :item="item"></card-jobfair>
                </el-col>
              </el-row>
              <el-row class="list-button">
                <el-col :span="24">
                  <el-link :underline="false" type="info" @click="moreTypeFn">更多场次 >></el-link>
                </el-col>
              </el-row>
            </div>
            <no-data v-else></no-data>
          </div>
        </section>
        <section class="seek"></section>
      </section>
      <footer-box></footer-box>
    </side-bar>
    <base-login @logined="init"></base-login>
  </div>
</template>

<script>
import CarouselTop from "@/components/Carousel/CarouselTop";
import CardJobfair from "@/components/Card/CardJobfair";

import { sp_data } from "@/datas/kind.js";

export default {
  name: "jobfair",
  components: {
    CarouselTop,
    CardJobfair,
  },
  data() {
    return {
      dialogVisible: false,
      carouselConfig: {
        height: "390px",
        autoplay: true,
        interval: 5000,
      },
      carouselList: [],
      filter: {
        search: true,
        pageNo: 1,
        pageSize: 15,
        keywords: "",
        total: 0,
        loading: false,
        finished: false,
        error: false,
      },
      imgConfig: {
        rocket: "https://o.bysjy.com.cn/kzp/kzp_web/rocket.png",
      },
      list: {
        search: [],
        ongoing: [],//正在进行列表
        hot: [],
        popular: [],//热门推荐
        school: [],//高校专场
        industry: [],//行业专场
        area: [],//区域专场
        // company: [],//名企专场
        realname:[],//实名企业专场
      },
      sp_keywords: {
        data: sp_data,
        value: "school",
      },
      hot_words: {
        data: [
          {
            name: "互联网类视频双选会",
          },
          {
            name: "长沙理工大学",
          },
        ],
        value: "",
      },
      timer: {
        search: null,
      },
      hot_open: false,//热门推荐 查看更多
      ongoing_open: false,//正在进行中 查看更多
    };
  },
  created() {
    this.getBanner();
    this.init();
  },
  methods: {
    init() {
      this.popularList();
      this.ongoingList();
      this.typeList();
    },
    getBanner() {
      var params = {
        type: 20,
      };
      var that = this;
      this.$util.get("kzp_common", "get_carousel", params).then((res) => {
        let { code, data } = res;
        if (code === 1) {
          that.$util.tansPics(data, "img");
          that.carouselList = data;
        }
      });
    },
    /**
     * 获取正在进行中的列表，无翻页，最多显示30个
     */
    ongoingList() {
      var params = {
        type: "ongoing",
      };
      var that = this;
      this.getList(params).then(function (res) {
        if (res.data) {
          var items = res.data
          that.$util.tansPics(items, "img", {default_img:  that.$util.error_img_jobfair});
          that.list.ongoing = items;
        }
      });
    },
    /**
     * 获取专场列表
     */
    typeList(type) {
      var params = {
        type: type || this.sp_keywords.value,
      };
      var that = this;
      this.getList(params).then(function (res) {
        if (res.data) {
          var items = res.data
          that.$util.tansPics(items, "img", {default_img:  that.$util.error_img_jobfair});
          that.list[params.type] = items;
        }
      });
    },
    /**
     * 获取热门推荐列表
     */
    popularList(){
      let params = {
        type: 'hot'
      };
      var that = this;
      this.getList(params).then(function (res) {
        if (res.data) {
          var items = res.data
          that.$util.tansPics(items, "img", {default_img:  that.$util.error_img_jobfair});
          that.list.popular = items;
        }
      });
    },
    /**
     * 获取视频双选会列表
     */
    getList(params) {
      var _self = this;

      // 获取站点省份
      params.province = this.$util.getProvinceConfig();

      return new Promise((resolve) => {
        this.$util
          .get("kzp_video_jobfair", "video_jobfair_list", params)
          .then((res) => {
            if (res && res.code === 1) {
              resolve(res);
            } else {
              resolve({ code: -1, data: [] });

              if (res.msg){
                _self.$message.error(res.msg);
              }
            }
          });
      });
    },
    spChangeFn(item) {
      var type = item.value;
      this.sp_keywords.value = type;

      var list = this.list;
      if (list[type] && list[type].length <= 0) {
        this.typeList(type);
      }
    },
    handleClose(done) {
      this.dialogVisible = false;
    },
    checkHotWord(item) {
      this.filter.keywords = item.name || "";
      this.searchFn();
    },
    searchFn() {
      this.filter.keywords = this.filter.keywords.replace(/(^\s*)|(\s*$)/g, "");
      var keywords = this.filter.keywords;

      this.$refs["router"].subpageto(
        "jobfair_search",
        { keywords: keywords },
        "jobfair_search"
      );
    },

    toDetailFn(item) {
      var video_jobfair_id = item.video_jobfair_id || 0;

      this.$refs["router"].subpageto(
        "jobfair_detail",
        { video_jobfair_id: video_jobfair_id },
        "jobfair_detail"
      );
    },
    moreFn(){
      this.$util.pageto('jobfair_search', {})
    },
    moreTypeFn(){
      let _self = this;
      this.$util.pageto('jobfair_search', {
        type:_self.sp_keywords.value
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.list-title-box {
  margin-bottom: 30px;
  overflow: hidden;

  > li {
    float: left;
    line-height: 25px;
    margin-right: 60px;
    font-weight: 500;
    cursor: pointer;

    &:hover {
      span {
        color: $titleColor;
      }
    }

    &:last-child {
      margin-right: 0;
    }

    span {
      color: #999;
      font-size: $titleFont;
    }

    img {
      display: none;
    }
  }

  .list-title {
    font-weight: bold;

    span {
      color: $titleColor;
    }

    img {
      vertical-align: top;
      display: inline-block;
      margin-right: 5px;
    }
  }
}

.jobfair {
  position: relative;
  height: 100%;

  .header {
    position: relative;
    padding: 0;

    .header-top {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      z-index: 3;
    }

    .wy-search {
      position: absolute;
      left: 50%;
      bottom: 0;
      z-index: 3;
      width: $mainWidth;
      // height: 167px;
      background-color: #fff;

      padding: 40px;
      box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.05);

      @include border-radius(10px);
      @include box-sizing(border-box);
      @include transform(translate(-50%, 25%));

      .hot-words {
        font-size: 12px;
        line-height: 17px;
        margin-top: 10px;
        color: #999;

        .hot-word {
          margin-right: 10px;
          cursor: pointer;

          &:hover {
            font-weight: bold;
          }

          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
  }

  .ongoing {
    background-color: rgba(250, 250, 250, 1);
    padding: 67px 0 40px;
  }

  .category {
    background-color: #fff;
    padding: 40px 0 60px;
  }

  .jobfair-card-box {
    overflow-y: auto;
    overflow-x: hidden;
    width: 100%;
    // max-height: 720px;
  }
  .hot-box{
    max-height: 713px;
    overflow: hidden;
  }
  .hot-opend{
    max-height: initial;
    overflow: visible;
  }
  .open-more-hot{
    cursor: pointer;
    text-align: center;
    margin: 10px auto;
    color: #999;
    font-size: 14px;
  }
  .down-arrow{
    translate: all;
    transform: rotate(-90deg);
  }
  .up-arrow{
    transform: rotate(90deg);
  }
}

.list-button {
  text-align: center;
  height: 0.5rem;
  line-height: .5rem;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/seeker/jobfair/App.vue